/* eslint react-hooks/exhaustive-deps: "warn" */
import { ReactNode, useContext } from 'react';

import cn from 'classnames';

import { ContentContext } from 'context/ContentContext';

import { AnimatedDotsBackground } from 'ui/atoms/AnimatedDotsBackground/AnimatedDotsBackground';
import { Button } from 'ui/atoms/Button/Button';

import styles from './DemoBlock.module.scss';

const baseClass = 'demo-block';

type Props = {
  title: string;
  description?: ReactNode;
  buttonTitle?: string;
  className?: string;
};

export const DemoBlock = ({ title, description, buttonTitle, className }: Props) => {
  const { secondaryNavigation, pageVars } = useContext(ContentContext);

  return (
    <section className={cn(styles[`${baseClass}-wrapper`], className)}>
      <AnimatedDotsBackground />

      <div className={styles[`${baseClass}-container`]}>
        <div className={styles[`${baseClass}-inner`]}>
          <div className={styles[`${baseClass}-text`]}>
            <h3>{title}</h3>

            {description && <div className={styles[`${baseClass}-description`]}>{description}</div>}
          </div>

          <Button
            size="xxl"
            type="dark"
            route={secondaryNavigation.book_demo.slug}
            className={styles[`${baseClass}-cta`]}
          >
            {buttonTitle || pageVars.common.book_demo_button}
          </Button>
        </div>
      </div>
    </section>
  );
};
